import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { TextInput, Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaPsicometricasInterface } from "../../../../../interfaces/FechaPsicometricasInterface";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";
import Header from "../../../../../components/HeaderForms/HeaderForms";

export const AutorizacionPSMEditarScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario =
    "AUTORIZACIÓN AL PROCESO DE EVALUACIONES PSICOMÉTRICAS";

  const [formData, setFormData] = useState({
    date: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit, setValue, reset } = useForm();

  const queryFechaPSI = useGetData<FechaPsicometricasInterface[]>({
    url: `/fecha_psicometricas/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_psicometricas"],
  });

  const mutateFechaPSI = useMutationData({
    url: `/fecha_psicometricas/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha_psicometricas"],
  });

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (queryFechaPSI.data && queryFechaPSI.data.length > 0) {
      const fechaps = queryFechaPSI.data[0];
      reset({
        fecha_autorizacionpsi: fechaps.fecha_autorizacionpsi || "",
      });
    }
  }, [queryFechaPSI.data, reset]);

  const navigate = useNavigate();

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}>
        <form
        onSubmit={handleSubmit((data) => {
          console.log(data);

          // Aseguramos que los valores seleccionados se incluyan
          const formData = {
            ...data,
          };

          // Mutación para guardar la Fecha Psicométrica
          mutateFechaPSI.mutate(
            {
              data: { fecha_autorizacionpsi: data.fecha_autorizacionpsi },
              tipo: "put",
            },
            {
              onSuccess: () => {
                navigate(`/psicometrica/${evaluadosList_id}`);
              },
              onError: (error) => {
                console.error("Error al guardar Fecha Psicométrica:", error);
              },
            }
          );
        })}
        className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}
      >
        {/* Header */}
        <Header titulo={tituloFormulario} />

        {/* Contenido del formulario */}
        <div className="p-6">
          <div className="text-center mb-8">
            <div className="flex justify-left items-center gap-2 mb-4">
              <p className={`mt-3 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>Ciudad de México a</p>
              <Controller
                name="fecha_autorizacionpsi"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <input
                    id="fecha_autorizacionpsi"
                    type="date"
                    value={
                      field.value ||
                      (queryFechaPSI.data && queryFechaPSI.data.length > 0
                        ? queryFechaPSI.data[0]?.fecha_autorizacionpsi || ""
                        : "")
                    }
                    onChange={(e) => field.onChange(e.target.value)}
                    className={`text-left w-auto border rounded ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                )}
              />
            </div>
            <h2 className={`text-xl font-bold mb-4 flex items-center ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              AUTORIZACIÓN AL PROCESO DE EVALUACIONES DE EVALUACIONES
              PSICOMÉTRICAS
            </h2>
          </div>

          <div className="space-y-6">
            <div className="flex items-start">
              <span className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>Yo</span>
              <TextInput
                type="text"
                name="name"
                value={`${queryEvaluado.data?.nombre || ""} ${
                  queryEvaluado.data?.apellido_paterno || ""
                } ${queryEvaluado.data?.apellido_materno || ""}`}
                onChange={handleInputChange}
                className={`flex-1 mx-2 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
              />
              <span className={`ml-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                , autorizo que me aplique todas las evaluaciones Psicométricas
              </span>
            </div>
            <p className={`text-justify ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              así como todas las necesarias para el proceso de evaluación, etc.
              Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A. de
              C.V. para que proporcione toda la información y documentación que
              derive de las evaluaciones de pruebas de confianza que me
              realicen.
            </p>
            <p className={`text-justify ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              En este acto autorizo y conozco el aviso de privacidad el cual se
              encuentra publicado en
              https://skyangel.com.mx/avisodeprivacidad.htlm, por lo cual en
              este acto consiento que SKA TRACKING AND SECURITY S.A. de C.V.
              podrá recabar mis datos personales de conformidad con los términos
              establecidos en dicho aviso.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              Bajo protesta de decir verdad hago constar que los datos
              proporcionados en el proceso de evaluación son verdaderos.
            </p>

            <div className="mt-12 text-center">
              <p className={`mb-8 font-bold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>ATENTAMENTE</p>
              <div className={`w-64 mx-auto border-t pt-2 ${isDarkMode ? "border-gray-400" : "border-black"}`}>
                <p className={`text-sm ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>NOMBRE Y FIRMA</p>
              </div>
            </div>
          </div>
        </div>

        {/* Botones */}
        <div className="mt-4 mb-4 px-4">
          <div className="flex justify-between">
            <Button
              color="red"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(-1);
              }}
              className={`bg-red-500 hover:bg-red-600 text-white dark:bg-red-600 dark:hover:bg-red-700`}
            >
              Regresar
            </Button>
            <button
              type="submit"
              className={`rounded px-4 py-2 ${isDarkMode ? "bg-green-600 hover:bg-green-700 text-white" : "bg-green-500 hover:bg-green-600 text-white"}`}
            >
              {" "}
              Guardar{" "}
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-700" : "bg-customBlue"}`}>
          <p className="text-sm text-white px-4">
            <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
            su reproducción, copia o sacar este documento de las Instalaciones
            de Skyangel
          </p>
        </div>
      </form>
      </div>
    </div>
  );
};
